import { useState } from 'react';
import { toast } from 'react-toastify';
import { FaPencilAlt } from 'react-icons/fa';
import { CreditAnalysis } from '../types';
import { fmtCurrency } from './analysisFormatters';

interface Props {
    row: CreditAnalysis;
    onSave: (uuid: string, num: number) => Promise<void>;
}

export default function EditableApprovedValue({ row, onSave }: Props) {
    const [editing, setEditing] = useState(false);
    const save = async (raw: string) => {
        setEditing(false);
        const num = parseFloat(raw.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'));
        if (isNaN(num)) return;
        try { await onSave(row.uuid, num); } catch { toast.error('Erro ao salvar'); }
    };
    if (editing) {
        return (
            <input
                autoFocus
                type="text"
                defaultValue={row.approvedValue || ''}
                onBlur={(e) => save(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') save((e.target as HTMLInputElement).value); if (e.key === 'Escape') setEditing(false); }}
                className="w-full px-1 py-0.5 text-sm text-right border border-blue-400 rounded bg-white dark:bg-slate-700 dark:text-gray-100 focus:outline-none"
            />
        );
    }
    return (
        <span onClick={() => setEditing(true)} className="flex items-center gap-1 w-full h-full min-h-[24px] dark:text-gray-200 cursor-pointer hover:text-blue-700 dark:hover:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/40 rounded px-1 justify-end border border-transparent hover:border-blue-300 dark:hover:border-blue-600" title="Clique para editar">
            <span>{row.approvedValue ? fmtCurrency(row.approvedValue) : '-'}</span>
            <FaPencilAlt className="text-[9px] text-gray-400 shrink-0" />
        </span>
    );
}
